/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseReservationDurationsValuesInner
 */
export interface GetConfig200ResponseReservationDurationsValuesInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseReservationDurationsValuesInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseReservationDurationsValuesInner
     */
    value: number;
}

/**
 * Check if a given object implements the GetConfig200ResponseReservationDurationsValuesInner interface.
 */
export function instanceOfGetConfig200ResponseReservationDurationsValuesInner(value: object): value is GetConfig200ResponseReservationDurationsValuesInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseReservationDurationsValuesInnerFromJSON(json: any): GetConfig200ResponseReservationDurationsValuesInner {
    return GetConfig200ResponseReservationDurationsValuesInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseReservationDurationsValuesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseReservationDurationsValuesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
    };
}

export function GetConfig200ResponseReservationDurationsValuesInnerToJSON(json: any): GetConfig200ResponseReservationDurationsValuesInner {
    return GetConfig200ResponseReservationDurationsValuesInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseReservationDurationsValuesInnerToJSONTyped(value?: GetConfig200ResponseReservationDurationsValuesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

